import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SiteShell, { Reveal } from './SiteShell';
import { GalleryTile, Lightbox } from './SiteBits';
import api from '../api/client';

const PAGE = 24;

/** Full photo gallery — the "View all" target from the landing rail. */
export default function GalleryPage() {
  const [s, setS] = useState({});
  const [images, setImages] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => { api.get('/settings/public').then((d) => setS(d || {})).catch(() => {}); }, []);

  const load = useCallback((p) => {
    setLoading(true);
    api.get(`/gallery?limit=${PAGE}&page=${p}`)
      .then((d) => {
        setImages((prev) => (p === 1 ? (d?.images || []) : [...prev, ...(d?.images || [])]));
        setTotal(d?.total || 0);
      })
      .catch(() => { if (p === 1) setImages([]); })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(1); }, [load]);

  const more = () => { const next = page + 1; setPage(next); load(next); };

  return (
    <SiteShell settings={s}>
      <div className="wrap" style={{ padding: '56px 20px 80px' }}>
        <Reveal>
          <p className="eyebrow">Gallery</p>
          <h2 style={{ fontSize: 38, fontWeight: 900, margin: '0 0 12px', letterSpacing: '-.4px' }}>
            Our work, in pictures
          </h2>
          <p className="lead">
            {total ? `${total} photo${total === 1 ? '' : 's'} and clip${total === 1 ? '' : 's'} from our teams and the homes we care for.` :
              'Photos and clips from our teams and the homes we care for.'}
          </p>
        </Reveal>

        {images.length === 0 && !loading ? (
          <p style={{ color: 'var(--muted)' }}>
            No photos or videos yet. <Link to="/" style={{ color: 'var(--brand)', fontWeight: 700 }}>Back to home →</Link>
          </p>
        ) : (
          <div className="gal-grid">
            {images.map((g, i) => (
              <GalleryTile key={g._id} item={g} onOpen={() => setLightbox(i)} />
            ))}
          </div>
        )}

        {images.length < total && (
          <div style={{ textAlign: 'center', marginTop: 34 }}>
            <button className="btn btn-ghost btn-lg" onClick={more} disabled={loading}>
              {loading ? 'Loading…' : `Load more (${total - images.length} left)`}
            </button>
          </div>
        )}
      </div>

      <Lightbox items={images} index={lightbox} onClose={() => setLightbox(null)} onIndex={setLightbox} />

    </SiteShell>
  );
}
